/*
 * Lazy-loads <video data-da-lazy-video> elements (used for mobile home videos).
 * The <source> tags carry data-src instead of src, so nothing is downloaded
 * until the video comes within ~half a screen of the viewport. Then the src is
 * filled in, the video loads and starts playing (muted, inline, looped).
 * Videos pause when scrolled far away and resume when they come back.
 * Hidden videos (display:none, e.g. the other breakpoint) are never loaded.
 */
(function () {
  if (window.__daLazyVideoInit) return;
  window.__daLazyVideoInit = true;

  var SELECTOR = 'video[data-da-lazy-video]';
  var loadObserver = null;
  var playObserver = null;

  function isShown(video) {
    return window.getComputedStyle(video).display !== 'none';
  }

  function hydrate(video) {
    if (video.dataset.daLazyLoaded) return;
    video.dataset.daLazyLoaded = '1';
    Array.prototype.forEach.call(video.querySelectorAll('source[data-src]'), function (source) {
      source.src = source.getAttribute('data-src');
      source.removeAttribute('data-src');
    });
    video.muted = true;
    video.playsInline = true;
    video.load();
  }

  function play(video) {
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function setupObservers() {
    if (loadObserver || !('IntersectionObserver' in window)) return;

    // Start loading when the video is within ~half a viewport of the screen
    // (kept small so the below-the-fold video does not compete with the hero on load).
    loadObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting && isShown(v)) {
          hydrate(v);
          play(v);
          loadObserver.unobserve(v);
        }
      });
    }, { rootMargin: '50% 0px 50% 0px' });

    // Pause when far off screen, resume when back (saves CPU / battery).
    playObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (!v.dataset.daLazyLoaded) return;
        if (entry.isIntersecting) play(v); else v.pause();
      });
    }, { rootMargin: '50% 0px 50% 0px' });
  }

  function watch(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var videos = Array.prototype.slice.call(scope.querySelectorAll(SELECTOR));
    if (!videos.length) return;

    setupObservers();

    videos.forEach(function (v) {
      if (v.dataset.daLazyWatched) return;
      v.dataset.daLazyWatched = '1';

      if (!loadObserver) {
        // Very old browsers without IntersectionObserver: just load and play.
        if (isShown(v)) { hydrate(v); play(v); }
        return;
      }
      loadObserver.observe(v);
      playObserver.observe(v);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { watch(document); });
  } else {
    watch(document);
  }

  // Shopify theme editor re-renders sections; pick up the new video elements.
  document.addEventListener('shopify:section:load', function (event) {
    watch(event.target);
  });
})();
